export enum VACCINATION_PAGES {
  NEW = "NEW",
  REVIEW = "REVIEW",
}
export enum VaccinationInitiatedFrom {
  BOTTOM_BAR = "BOTTOM_BAR",
  RECOMMENDATION_CARD = "RECOMMENDATION_CARD",
}

export enum VACCINE_ADDED_FROM {
  TEXT_INPUT = "TEXT_INPUT",
  RECOMMENDED_VACCINE_BUTTON = "RECOMMENDED_VACCINE_BUTTON",
  NUDGE = "NUDGE",
}
